import { render, staticRenderFns } from "./delivery-old.vue?vue&type=template&id=0a2a9729&scoped=true&"
import script from "./delivery-old.vue?vue&type=script&lang=js&"
export * from "./delivery-old.vue?vue&type=script&lang=js&"
import style0 from "./delivery-old.vue?vue&type=style&index=0&id=0a2a9729&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2a9729",
  null
  
)

export default component.exports